// @flow
import * as React from 'react';

import s from './DropDown.scss';
import PickListItem from '../PickListItem/PickListItem.jsx';
import TriangleDown from '../images/triangle-down.svg';

type Props = {
  disabled: boolean,
  width: number,
  label: string,
  items: any[],
  selectedIndex: number,
  onItemClick: (itemIndex: number) => void,
}

type State = {
  dropDownOpen: boolean,
}


export class DropDown extends React.PureComponent<Props, State> {
  state = {
    dropDownOpen: false,
  }

  render() {
    const { width, disabled } = this.props;
    const modalStyle = this.getModalStyle();


    return (
      <div id={s.wrapper}>
        <div className={modalStyle.join(' ')}>
          <div
            onClick={() => this.onHeaderClick()}
            className={s.header_wrapper}
            style={{width}}
          >
            <button
              style={{width}}
              className={[s.header2, s.map_btn].join(' ')}
              disabled={disabled}
            >
              { this.renderLabel() }
            </button>
            {
              !disabled &&
              <img
                className={[s.chevron, s.triangle].join(' ')}
                src={TriangleDown}
                alt="down triangle"
              />
            }
          </div>
          <ul id="container" className={s.selection_container} style={{width}}>
            { this.renderItems() }
          </ul>
        </div>
        {
          this.state.dropDownOpen &&
          <div
            className={s.modal_bg}
            onClick={() => {this.setState({ dropDownOpen: false })} }
          >
          </div>
        }
      </div>
    )
  }


  ///////////////////////////////////////////////////////////////////////
  //  RENDER METHODS
  ///////////////////////////////////////////////////////////////////////

  renderLabel() {
    const { items, selectedIndex, label } = this.props;
    if (!items[selectedIndex]) {
      return label;
    } else {
      return items[selectedIndex];
    }
  }

  renderItems() {
    const { items, selectedIndex } = this.props;
    if (!items) return [];

    return (items.map((item, i) => {
      return (
        <div id={selectedIndex === i ? "selected" : null} key={i}>
          <PickListItem
            name={item}
            selected={selectedIndex === i}
            disabled={false}
            onItemClick={ ()=> this.onProcessItemClick(i) }
          />
        </div>
      )
    }): any[])
  }




  ///////////////////////////////////////////////////////////////////////
  //  UTIL METHODS
  ///////////////////////////////////////////////////////////////////////
  getModalStyle() {
    let style = [s.body];
    if (this.state.dropDownOpen) {
      style = [s.body, s.open];
    } else {
      style = [s.body, s.closed];
    }
    return style
  }


  ///////////////////////////////////////////////////////////////////////
  //  EVENT HANDLERS
  ///////////////////////////////////////////////////////////////////////


  onHeaderClick() {
    this.setState({ dropDownOpen: true });

    const scrollInterval = setInterval(() => {
      const container = document.getElementById('container');
      if (container) {
        this.scrollToElement(container);
        clearInterval(scrollInterval);
      }
    }, 50)

  }

  onProcessItemClick(i: number) {
    this.setState({ dropDownOpen: false });
    this.props.onItemClick(i);
  }

  scrollToElement(container: HTMLElement ) {
    let selectedItem = document.getElementById('selected');

    if (container && selectedItem) {
      container.scrollTop = selectedItem.offsetTop;
    }
  }

}



export default DropDown
